/**
 * 当前项目的全局方法
 * */
import Vue from 'vue';

import Toast from '@/components/modal/toast';
import Login from '@/components/modal/login';
import Gift from '@/components/modal/gift';
import Grade from '@/components/modal/grade';
import Vip from '@/components/modal/vip';


export default {
  CreateApp(comp, config = {}, events = [], el = document.createElement('div')) {
    config = {...config};
    const Comp = Vue.extend(comp);
    let dom = new Comp({
      el,
      store: this.$store,
      router: this.$router,
    });
    dom.Product = this.Product;
    events.forEach(event => {
      let fn = config[event];
      fn && dom.$on(event, (...arg) => fn.call(this, ...arg, dom));
      delete config[event];
    });
    Object.assign(dom, config);
    return dom;
  },
  ShowToast(config = {}, dfBody) {
    let body = dfBody || document.body;
    body = body.$el || body;
    typeof config === 'string' && (config = {content: config});
    let closed = config.closed;
    closed && closed.bind(this);
    config.closed = async (...arg) => {
      closed && await closed(...arg);
      let dom = arg.pop();
      if (dom) {
        body.removeChild(dom.$el);
        dom = null;
      }
    };
    let dom = this.CreateApp(Toast, config, ['closed']);
    body.appendChild(dom.$el);
    return dom;
  },
  ToLogin(config = {}, dfBody) {
    let body = dfBody || document.body;
    body = body.$el || body;
    typeof config === 'string' && (config = {content: config});
    let dom = this.CreateApp(Login, config, ['login-success', 'input', 'pwd-success', 'bind-success', 'error']);
    body.appendChild(dom.$el);
    return dom;
  },
  ShowGift(config = {}, dfBody) {
    let body = dfBody || document.body;
    body = body.$el || body;
    let dom = this.CreateApp(Gift, config, ['close-gift','check-class']);
    body.appendChild(dom.$el);
    return dom;
  },
  SelectGrade(config = {}, dfBody = document.body) {
    let body = dfBody || document.body;
    body = body.$el || body;
    let dom = this.CreateApp(Grade, config, ['select']);
    body.appendChild(dom.$el);
    return dom;
  },
  ShowVip(config = {}, dfBody = document.body) {
    this.$store.commit('setIsShowPayPopup', true);
    let body = dfBody || document.body;
    body = body.$el || body;
    let dom = this.CreateApp(Vip, config);
    body.appendChild(dom.$el);
    return dom;
  },
  async GetUserInfoApi(uid) {
    let userInfo = await this.http.NEWUserInfo({
      uid,
      ...this.Product,
      is_web: 1,
    });
    if (!userInfo.phone) {
      userInfo = {};
      this.$err({
        code: 1,
        msg: '账号信息变更，请重新登录',
      });
    }
    this.$store.commit('setUserInfo', userInfo);
    return this.$store.getters.userInfo;
  },
  // 获取年级列表
  async GetGradeList() {
    let res = await this.http.getGrade({ type_id: 3, is_web: 1, uid: this.$store.getters.userInfo.uid});
    this.$store.commit('setAllGrades', res);
    return res;
  },
  // 获取自定义页面编号code
  GetPagesCode() {
    let {currGrade, currTab} = this.$store.getters;
    let {pageCode} = this.$store.state;
    let code = '';
    if (+currGrade.pid === 3 && currTab === 'tb') {
      code = pageCode[+currGrade.pid].tb[+currGrade.id];
    } else if(+currGrade.pid === 5){  
      code = pageCode[currGrade.id][currTab];
    } else {
      code = pageCode[+currGrade.pid !== 2 ? currGrade.pid : currGrade.id][currTab];
    }
    this.$store.commit('setCurrPageCode', code);
  },
  // 获取微信信息成功回调
  async GetWxInfoSucc(isNoPhone, innerErr) {
    let uid = this.$store.getters.userInfo.uid;
    if (isNoPhone === true) {
      // 新用户绑定手机
      return await new Promise((resolve) => {
        this.ToLogin({
          value: 'bind-phone',
          wxBind: innerErr.data,
          'bind-success': resolve,
        });
      });
    } else if (uid) {
      // 绑定微信
      // await this.http.NEWBindWx({code, uid});
      // return await this.GetUserInfoApi(uid);
    } else {
      // 微信登录
      // let fn = this.$options.wxLoginSuccess;
      let loginRes = isNoPhone;
      this.$store.commit('setNewApiToken', loginRes.token);
      this.$store.commit('setOldToken', loginRes.old_token);
      this.$store.commit('setPrevLoginType', 'wx');
      this.$store.commit('setShowClose', false);
      this.ShowUserGiftImg(loginRes);
      loginRes = await this.GetUserInfoApi(loginRes.uid);
      this.SetUserGradeInfo(loginRes);
      if(loginRes.uid){
        location.reload();
      }
      // if (fn) {
      //   fn = fn.bind(this);
      //   await fn(loginRes, isNoPhone);
      // }
      return loginRes;
    }
  },

  // wx登录获取微信信息
  async GetWxInfo(id, init = true) {
    let {code, state, isBindWx, isUnbindWx} = this.$route.query;
    let {qrState} = this.$store.state;
    let loginRes = null;
    let err = null;
    this.$store.commit('setQrState', '');
    if (!qrState || !state) {
      // 非wx登录中
      loginRes = {code: 111, msg: '非微信登录！'};
    } else if (state !== qrState) {
      // 地址已失效
      loginRes = {code: 112, msg: '地址已失效!'};
    } else if (!code) {
      // 用户授权失败
      err = {code: 113, msg: '用户授权失败!'};
    } else {
      // 授权成功

      try {
        if (isBindWx || isUnbindWx) {
          // 绑定/解绑 微信
          let uid = this.$store.getters.userInfo.uid;
          await this.http[isUnbindWx ? 'NEWUnBindWx' : 'NEWBindWx']({code, uid});
          this.ShowToast(isUnbindWx ? '解绑成功！' : '绑定成功！');
          loginRes = await this.GetUserInfoApi(uid);
        } else {
          // 登录
          let res = await this.http.NEWWxLogin({code});
          loginRes = await this.GetWxInfoSucc(res);
          this.$store.commit('setPrevLoginType', 'wx');
        }
      } catch (innerErr) {
        if (+innerErr.code === 10139) {
          // 未绑定手机号
          loginRes = await this.GetWxInfoSucc(true, innerErr);
          this.$store.commit('setPrevLoginType', 'wx');
        } else {
          err = innerErr;
        }
      }
    }
    init && setTimeout(() => {
      location.replace(location.href.replace(/[&?]((code=\w+)|(state=\w+)|(isBindWx=\w+)|(isUnbindWx=\w+))/gi, ''));
    });
    if (err) throw err;
    return loginRes;
  },
  // 获取 app(页面名称) 下的audio(ref名称)组件的 vnode
  GetAppAudio(app = 'App', audioRefName = 'audio') {
    let audio = null;
    for (let parent = this.$parent; parent && !audio; parent = parent.$parent) {
      audio = parent.$options && parent.$options.name === app && parent.$refs[audioRefName] || null;
    }
    return audio || null;
  },

  /**
   * 新页面打开路由
   *
   * @param {Object|String} path 跳转的路由
   * */
  OpenRouter(path,isOpen = false) {
		let {allTabsList} = this.$store.getters
    let link = '';
    if (typeof path === 'string') {
      link = path;
    } else if (path.name) {
      link = path.name.replace(/[A-Z]/g, s => '/' + s.toLocaleLowerCase());
    } else {
      link = path.path;
    }
    let query = path.query || {};
    !/\?/.test(link) && (link += '?');

    Object.keys(query).forEach(k => link += `&${k}=${query[k]}`);
		let route = this.$route;
		let curr = '';
		let currTab = ''
		let currObj = allTabsList.find((item)=>{
			return item.value === this.$route.path.split('/')[3]
		})
		if(currObj&&!isOpen){
			currTab = currObj.value;
			curr = `&currTab=${currTab}`;
		}
    let url = location.href.split('#')[0] + '#' + link + curr;
    let win = window.open(url);
    
    if(win){
      win.sessionStorage.setItem('newPage', true);
      win.sessionStorage.setItem('audio', null);
    }else if(win === null){
      alert('当前弹窗已被浏览器阻止，请先修改浏览器设置');
    }
  },

  // 获取当前用户年级会员产品信息
  async GetCurrGradeVip() {
    try {
      let {userInfo, currGrade} = this.$store.getters;
      let res = await this.http.NEWGetProductId({uid: userInfo.uid, nianji_id: currGrade.id});
      userInfo.is_vip = res.is_vip === 1;
      this.$store.commit('setCurrUserVip', res);
      this.$store.commit('setUserInfo', userInfo);
      return res;
    } catch (err) {
      throw err;
    }
  },

  /**
   * 活动倒计时
   * @param {number} number 活动时间(毫秒)
   * @param {object} config { key 当前活动时间变量 format 转换时间格式 style 转换时间样式}
   * @param {function} fn  活动时间结束之后需要做的事件
   */
  ActivityCountDown(number, config = {}, fn) {
    let timer = null, end_time = '';
    if (number) {
      timer = setInterval(() => {
        number -= 1000;
        end_time = this.Tools.numberToTime(number, config.format).replace(/\d+/g, n => `<span style="${config.style}">${n}</span>`);
        this[config.key] = end_time;
        if (number <= 0) {
          clearInterval(timer);
          timer = null;
          fn && typeof fn === 'function' && fn();
        }
      }, 1000);
    }
  },

  /**
   * 根据用户年级来设置tab栏的年级
   * @param {object} info // 当前用户信息 
   */
  async SetUserGradeInfo(info = $store.getters.userInfo){
    if(info.nianji_id){
      let gradeList = await this.GetGradeList();
      let userGarde = gradeList.find(e => +e.id === +info.select_nianji_id) || gradeList.find(e => +e.id === +info.nianji_id);
      userGarde && this.$store.commit('setCurrGrade', userGarde);
    }
  },
  
  /**
   * 显示新用户活动礼品图
   * @param {object} res 
   */
  ShowUserGiftImg(res, fn){
    if (res.is_register && res.is_give_vip === 1 && res.vip_img) {
      this.ShowGift({
        imgUrl: res.vip_img,
        'close-gift': fn
      })
    }else{
     fn && fn()
    }
  }
}